import { VoidedObject } from "@/shared/models/voided-object.model";
import { Condition } from "./Condition";
import { Field } from "./Field";
import { FormRule } from "./FormRule";
import { UiSetup } from "./UiSetup";

export class FormTemplate extends VoidedObject {
  name!: string;
  category!: string;
  icon!: string;
  version?: number;
  prompt?: string;
  dateUpdatePromt?: number;
  fields!: Field[];
  uiSetup?: UiSetup;
  formRules!: FormRule[];
  formConditions?: Condition[];
  state!: string;
  id?: string;
  _key?: string;
  partialSave?: boolean;
}
